import { Box, CircularProgress, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppStore } from "../../../hooks/useStores.tsx";
import { CampaignEntityStatus } from "../../../models/common.ts";
import iframeStore from "../../../pages/IframeNew/iframe-store.tsx";
import ConfirmationPopup from "../../common/ConfirmationPopup/ConfirmationPopup.tsx";
import styles from "./IframeAdsEditorInfoPopup.module.scss";

const IframeAdsEditorInfoPopup = () => {
	const { t } = useTranslation("translation", { keyPrefix: "IframeAdsEditorInfoPopup" });
	const { uiStore, campaignStore } = useAppStore();
	const [hasTimedOut, setHasTimedOut] = useState(false);

	const isLoading =
		iframeStore.isIframe() &&
		(campaignStore.selectedTemplate?.status === CampaignEntityStatus.PENDING || !campaignStore.selectedTemplate);

	useEffect(() => {
		if (isLoading) {
			let timeOut = 10 * 60 * 1000;
			const timeoutId = setTimeout(() => {
				setHasTimedOut(true);
			}, timeOut);

			return () => {
				clearTimeout(timeoutId);
			};
		} else {
			setHasTimedOut(false);
		}
	}, [isLoading]);

	return (
		<ConfirmationPopup
			paperClassName={styles.IframeAdsEditorInfoPopup}
			onClose={() => {
				return;
			}}
			title={t("title")}
			loading={isLoading && !hasTimedOut}
			hideCloseIcon={true}
			hideCancel={true}
			description={
				<Box className={styles.descriptionBox}>
					<Typography className={`${styles.description} ${hasTimedOut ? styles.errorText : ""}`}>
						{hasTimedOut ? t("error") : t("description")}
					</Typography>
					{!hasTimedOut && <CircularProgress size={24} className={styles.loader} />}
				</Box>
			}
			open={iframeStore.isAdsEditorIframe() && uiStore.iframeAdsEditorInfoPopup}
		/>
	);
};

export default observer(IframeAdsEditorInfoPopup);
